export default __webpack_public_path__ + "static/media/duibikapian.3e950e38.png";